import {ClipboardEvent} from 'react';

/**
 * For middle-truncated texts, we render two elements that both contain the full text,
 * and use styling to control whether the start or end portion is shown. If the user
 * selects text across the two elements, the selection would contain repeated text,
 * which is problematic if the user wants to copy what they selected.
 *
 * This function checks the selected text and removes repeated portion of the text
 * before copying to clipboard. It can handle both full and partial selections.
 *
 * @param e - The clipboard event
 * @param fullText - The expected non-truncated text
 */
export const copyMiddleTruncatedText = (
  e: ClipboardEvent,
  fullText: string
) => {
  const selection = document.getSelection();
  const selectedText = selection?.toString() ?? '';
  if (selectedText.length > fullText.length) {
    let textToCopy: string;
    const [startSelection, endSelection] = selectedText.split('\n');
    const isStartFull = startSelection === fullText;
    const isEndFull = endSelection === fullText;
    if (isStartFull && isEndFull) {
      // both sides are fully selected; copy full text
      textToCopy = fullText;
    } else if (isStartFull) {
      // start is fully selected but end is partially selected; just use end text
      textToCopy = endSelection;
    } else if (isEndFull) {
      // end is fully selected but start is partially selected; just use start text
      textToCopy = startSelection;
    } else {
      // both sides are partially selected; slice text down to selected portion
      const sliceStart = fullText.length - startSelection.length;
      const sliceEnd = fullText.length - endSelection.length;
      textToCopy = fullText.slice(sliceStart, sliceEnd * -1);
    }
    e.clipboardData.setData('text/plain', textToCopy);
    e.preventDefault();
  }
};
